module.exports = __webpack_public_path__ + "img/header2.90c1baaf.png";